<script setup lang="ts">
import store from '@/store'
import { EStoreModules } from '@/store/storeType'
import { EUserActions } from '@/store/userStore/UserStoreTypes'
import type { UserModel } from '@/types/models/UserModel'
import { PrimaryButton } from '../../Buttons'

type Props = {
    user: UserModel
}
const props = defineProps<Props>()

const handleActivate = () =>
    store.dispatch(`${EStoreModules.USER}/${EUserActions.UPDATE_USER}`, {
        data: { ...props.user, active: 1 },
        userId: props.user.id
    })
</script>

<template>
    <PrimaryButton :label="$t('user.actions.activeAction')" @click="handleActivate" />
</template>
